import { FranchisePagePageData } from '../franchise-page';
import { FranchiseServicePageData } from '../franchise-service';

function useServiceTypeBlockFilter(args: FranchisePagePageData, focusedType: keyof FranchisePagePageData): FranchisePagePageData;
function useServiceTypeBlockFilter(args: FranchiseServicePageData, focusedType: keyof FranchiseServicePageData): FranchiseServicePageData;
function useServiceTypeBlockFilter(
    data: Partial<FranchisePagePageData & FranchiseServicePageData>,
    focusedType: keyof FranchisePagePageData | keyof FranchiseServicePageData,
): FranchisePagePageData | FranchiseServicePageData {
    const bannedServiceAnchors = (data?.franchise?.bannedInternalLinks || []).filter(link => link && link.includes('#')).map(link => link && link.split('#')[1]);
    const relevantServices = (data?.franchise?.servicesProvidedFilterable || []).map(x => x?.serviceLine).reduce<string[]>((acc, val) => {
        if (val) {
            return [...acc, ...val.split(',')];
        }
        return acc;
    }, []);
    let removeNext = false;

    if (!focusedType) return data as FranchisePagePageData | FranchiseServicePageData;

    if (!data || !(focusedType in data)) {
        return data as FranchisePagePageData | FranchiseServicePageData;
    }

    const theData = data[focusedType];

    if (theData && 'sections' in theData && theData.sections) {
        const reparsedData = theData.sections.reduce<unknown[]>((acc, val) => {
            if (val) {
                const { __typename: typeName } = val;
                if (typeName === 'CsAnchor' && bannedServiceAnchors.includes(val.anchorId)) {
                    removeNext = true;
                    return acc;
                }
                if (typeName === 'CsShowBelowIfGroup') {
                    if (!val.linkedServiceType) {
                        return acc;
                    }
                    const splitServiceMappings = (val.linkedServiceType.franchiseServiceMapping || '').split(',').map(x => x.trim());

                    if (!splitServiceMappings.some(y => relevantServices.includes(y))) {
                        removeNext = true;
                        return acc;
                    }
                    return acc;
                }
                if (removeNext) {
                    removeNext = false;
                    return acc;
                }
                return acc.concat(val);
            }
            return acc;
        }, []);

        return {
            ...data,
            [focusedType]: {
                ...data[focusedType],
                sections: reparsedData,
            },
        } as FranchisePagePageData | FranchiseServicePageData;
    }

    return data as FranchisePagePageData | FranchiseServicePageData;
}

export default useServiceTypeBlockFilter;
